const css = () => `
.p-accordion.p-accordion-borderless > .p-accordionpanel {
  border: none; 
}
.p-accordion .p-accordioncontent-wrapper {
  /* limits the child content from overflowing the accordion panel's width */
  min-width: 0;
}
`;

export default {
  css,
};
